import { useState, useEffect, useRef } from 'react';

const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState('up');

  const prevScrollY = useRef(0);

  useEffect(() => {
    // TODO: pageYOffset is deprecated
    prevScrollY.current = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const newScrollDirection = scrollY > prevScrollY.current ? 'down' : 'up';
      setScrollDirection(newScrollDirection);
      prevScrollY.current = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener('scroll', updateScrollDirection);

    return () => window.removeEventListener('scroll', updateScrollDirection);
  }, []);

  return scrollDirection;
};

export { useScrollDirection };
